<template>

    <panel-navigation>
  
      <div v-if="search" class="float-right ml-5 -mt-1">
        <v-select
          v-model="searches[0].properties.run_at_timezone"
          hide-details
          :items="['EST', 'PST']"
          outlined
          dense
          style="width: 100px; background: #FFFFFF;"
          @change="saveRunAt()"
        ></v-select>
      </div>

      <div v-if="search" class="float-right ml-5 -mt-1">
        <v-select
          v-model="searches[0].properties.run_at"
          hide-details
          :items="['12 AM','1 AM','2 AM','3 AM','4 AM','5 AM','6 AM','7 AM','8 AM','9 AM','10 AM','11 AM','12 PM','1 PM','2 PM','3 PM','4 PM','5 PM','6 PM','7 PM','8 PM','9 PM','10 PM','11 PM']"
          outlined
          dense
          style="width: 100px; background: #FFFFFF;"
          @change="saveRunAt()"
        ></v-select>
      </div>
  

      <div v-if="search" class="float-right ml-5 -mt-1 pt-3" style="font-size: 12px;">
        Run At:
      </div>

      <div v-if="search" class="float-right ml-5 -mt-1">
        <v-select
          v-model="searches[0].properties.frequency"
          hide-details
          :items="['7 days', '10 days', '14 days', '15 days', '30 days']"
          outlined
          dense
          style="width: 100px; background: #FFFFFF;"
          @change="saveRunAt()"
        ></v-select>
      </div>
  

      <div v-if="search" class="float-right ml-5 -mt-1 pt-3" style="font-size: 12px;">
        Frequency:
      </div>
      
      <h1 class="text-lg font-semibold mb-3">LSA Audit</h1>
  
      <hr class="border-b border-gray-100 mb-3">

      <v-skeleton-loader v-if="fetching" type="article, article, article"></v-skeleton-loader>

      <div v-else>

        <div v-if="me && search" class="dashboard-box stats-box w-full px-2 mb-5">
           <v-card
            class="pa-2"
            tile
          >
            <div class="p-3">
              <v-tabs>
                  <v-tab v-for="(localSearch, index) in searches" @click="search = localSearch; searchKey++;">{{ localSearch.keyword }}</v-tab>
                  <v-tab @click="show_add_keyword = true" v-show="me.allowed_lsa_keywords > searches.length">
                      + Add Keyword
                  </v-tab>
              </v-tabs>
            </div>
          </v-card>
        </div>
        
        <div v-if="search && !show_add_keyword">
          <LSAAudit :search="search" :key="searchKey" />
        </div>
    
        <div v-else class="dashboard-box stats-box w-full px-2 -mx-2">
          <v-card
            class="pa-2"
            tile
          >
            <div class="p-3">
              <div class="lsa-audit-left-part">
                <vue-google-autocomplete id="rg_map_lsa_audit" classname="form-control" placeholder="Search for your business" v-on:placechanged="selectPlace" types="establishment"></vue-google-autocomplete>
              </div>

              <div class="lsa-audit-right-part">
                  <input type="text" v-model="lsa_keyword" placeholder="Keyword" style="padding-left: 15px; height: 57px; width: 100%; outline: none; background: #efefef; border-radius: 5px; margin-bottom: 15px; font-size: 12px;" />
              </div>

              <div class="lsa-audit-button">
                  <div v-if="!show_add_keyword" class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-4 rounded cursor-pointer float-right ml-2" @click="submitLsaAudit();"><i class="fa fa-plus mr-2"> </i> RUN AUDIT</div>

                  <div v-if="show_add_keyword" class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-4 rounded cursor-pointer float-right ml-2" @click="submitLsaAudit();"><i class="fa fa-plus mr-2"> </i> ADD KEYWORD</div>
              </div>

              <div style="clear: both;"></div>

              <div class="lsa-audit-left-part">
                <input type="text" v-model="lsa_company_name" placeholder="LSA Company Name" style="padding-left: 15px; height: 57px; width: 100%; outline: none; background: #efefef; border-radius: 5px; margin-bottom: 15px; font-size: 12px;" />
              </div>

              <div style="clear: both;"></div>

              <br />

              <h2>Notes:</h2>

              <div style="padding-top: 10px; font-size: 12px;">
                - Search for your exact business in its location, we will use that location to search for competitors nearby
                <br />
                - Enter exact keyword such as "roofer", "HVAC" or "family lawyer" (without the quotes)
                <br />
                - If the business has a different name on LSA than the GBP profile, make sure that is updated in the LSA Company Name field
                <br />
                - Do not include words like "near me" or "in [city]" in the keyword box
                <br />
                - Once you submit the audit, the keyword cannot be changed and it has to match your main job as shown in your LSA profile
                <br />
                - This report will run once every week to track changes in rankings and visibility
                <br />
                - The report will run at 10 AM PST, please check results around that time after your submit the information
              </div>
            </div>
          </v-card>
        </div>
      </div>
  
    </panel-navigation>
  
  </template>
  
  <script>
  import { mapState } from 'vuex'
  import PanelNavigation from '@/components/PanelNavigation.vue'
  import { GetSuggestions } from '@/utils/PlaceUtils'
    // import { GetPlaceDetails } from '@/utils/PlaceUtils'
    import axios from 'axios'
    import moment from 'moment'
    import $ from 'jquery'
    import LSAAudit from '@/views/local-recon/ReportsTemplates/LSAAudit.vue'
    import VueGoogleAutocomplete from "vue-google-autocomplete";

  export default {
    metaInfo () {
      return {
        title: "LSA Audit | " + this.$appName
      }
    },
  
    computed: {
      ...mapState({
        me: state => state.me.me,
      }),
        locationFoundItems () {
            return this.locationEntries
        }
    },
  
    components: {
      PanelNavigation,
      LSAAudit,
      VueGoogleAutocomplete
    },
  
    data () {
      return {
        autocompleteLocationModel: null,
        locationSearchText: null,
        locationEntries: [],

        business_location: {},

        lsa_keyword: "",

        lsa_company_name: "",

        show_add_keyword: false,

        searches: [],

        search: null,
        fetching: true
      }
    },
  
    methods: {
        async getSearch() {
            this.searchKey++;

            let self = this;

            let response = await axios.get(process.env.VUE_APP_API_ENDPOINT + '/local-recon/get-business-lsa-audit', {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                },
            });

            if (response.data.search)
              this.search = response.data.search;

            if (response.data.searches) {
              this.searches = response.data.searches;

              for (var i in this.searches) {
                this.searches[i].properties.searches.list.reverse();
              }

              this.search = response.data.searches[0];
            }

            if (this.search) {
              let bizHours;

              for (var i in this.search.properties.summary.items) {
                if (this.search.properties.summary.items[i].title == 'Business Hours') {
                  bizHours = JSON.parse(JSON.stringify(this.search.properties.summary.items[i]));
                  this.search.properties.summary.items[i].hidden = true;
                }
              }

              console.log('this.search.properties.summary.items', this.search.properties.summary.items);

              console.log('bizHours', bizHours);

              try {
                let newItems = [
                    ...this.search.properties.summary.items.slice(0, 2),
                    bizHours,
                    ...this.search.properties.summary.items.slice(2)
                ];

                this.search.properties.summary.items = newItems;
              }
              catch (e) {}
              
              if (!this.search.properties.run_at) {
                this.search.properties.run_at = '10 AM';
                this.search.properties.run_at_timezone = 'PST';
              }

              if (!this.search.properties.frequency) {
                this.search.properties.frequency = '7 days';
              }
            }

            this.fetching = false;

            // setTimeout(function() {
            //   self.getSearch();
            // }, 5000);
        },

        async saveRunAt() {
          let response = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/local-recon/save-run-at', {
              id: this.search.id,
              run_at: this.search.properties.run_at,
              run_at_timezone: this.search.properties.run_at_timezone
          } , {
              headers: {
                  'Authorization': 'Bearer ' + this.$store.state.auth.jwt
              },
          });
        },

        async submitLsaAudit() {
            let self = this;

            if (!this.business_location.place_id || !this.lsa_keyword) {
                return;
            }

            this.fetching = true;

            if (this.lsa_company_name) {
              this.business_location.name = this.lsa_company_name;
            }

            let response = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/local-recon/submit-lsa-audit', {
                widget_uuid: null,
                business_location: this.business_location,
                keyword: this.lsa_keyword,
                lsa_company_name: this.lsa_company_name,
                ongoing: 1
            } , {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                },
            });

            this.getSearch();

            this.show_add_keyword = false;
        },

        getHostname: function(item) {
            return new URL(item.listing.url).hostname.replace("www.", "");
        },
        formatDate: function(date) {
            return moment(String(date)).format('MM/DD/YYYY')
        },
        validateDomain(domain) {
            domain = domain.replace("www.", "");
            var res = domain.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
            return (res !== null)
        },

        getAddressObject(address_components) {
        var ShouldBeComponent = {
            street_number: ["street_number"],
            zip: ["postal_code"],
            address: ["street_address", "route"],
            state: [
            "administrative_area_level_1",
            "administrative_area_level_2",
            "administrative_area_level_3",
            "administrative_area_level_4",
            "administrative_area_level_5"
            ],
            city: [
            "locality",
            "sublocality",
            "sublocality_level_1",
            "sublocality_level_2",
            "sublocality_level_3",
            "sublocality_level_4"
            ],
            country: ["country"]
        };

        var address = {
            street_number: "",
            zip: "",
            address: "",
            state: "",
            city: "",
            country: ""
        };
        address_components.forEach(component => {
            for (var shouldBe in ShouldBeComponent) {
            if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
                if (shouldBe === "country") {
                address[shouldBe] = component.short_name;
                } else {
                address[shouldBe] = component.long_name;
                }
            }
            }
        });
        return address;
        },
        filterPlaces (item, queryText, itemText) {
        return true
        },
        selectPlace(addressData, placeResultData, id) {
          let that = this

          that.business_location = placeResultData;

          that.lsa_company_name = that.business_location.name;

          return;

          // $.get("https://maps.googleapis.com/maps/api/geocode/json?place_id=" + placeResultData.place_id + "&fields=name,rating,formatted_phone_number&key=AIzaSyANqXQPtxZhmpNYyvoBPBrnatNxGMvN9Ks", function(response) {
          //   that.company_name = placeResultData.name;

          //   console.log('response', response)

          //   that.business_location = response.results[0];

          //   // let address = that.getAddressObject(response.results[0].address_components);
          //   // let business_location = {};
          //   // business_location.street_number = address.street_number;
          //   // business_location.address = address.address;
          //   // business_location.city = address.city;
          //   // business_location.state = address.state;
          //   // business_location.zip = address.zip;
          //   // business_location.country = address.country;

          //   // business_location.lat = response.results[0].geometry.location.lat;
          //   // business_location.lng = response.results[0].geometry.location.lng;
          //   // business_location.place_id = response.results[0].place_id;

          //   // that.business_location = business_location;
          // });
        },
    },
  
    created() {
      this.getSearch();
    },
  
    watch: {

        'search': {
          handler() {
            this.saveRunAt()
          }
        },

        locationSearchText (newVal) {
          var that = this;

          // If less than 3 chars typed, do not search
          if (!newVal || newVal.length <= 3) return

          // Call the method from the previous section here
          GetSuggestions(newVal)
              .then(function (res) {
              that.locationEntries = res;
              })
              .catch(function () {
              that.business = false;
              that.step = 1;
              })
        }
    }
  }
  </script>
  
  <style>
    .lsa-audit-left-part {
        float: left;
        width: calc(50% - 60px);
        padding-right: 10px;
    }

    .lsa-audit-right-part {
        float: left;
        width: calc(50% - 60px);
    }

    .lsa-audit-button {
        float: right;
    }

    #rg_map_lsa_audit {
      font-size: 12px;
      border-radius: 5px !important;
      height: 57px;
      background: rgb(239, 239, 239) !important;
      border: 0px;
    }

    @media screen and (max-width: 500px) {
      .lsa-audit-left-part {
        float: none;
        width: 100%;
        padding-right: 0px;
        margin-bottom: 10px;
      }

      .lsa-audit-right-part {
          float: none;
          width: 100%;
      }

      .lsa-audit-button {
          float: none;
      }
    }
  </style>